window.custom_accordion_slide = function(){
    var $accsli = jQuery.noConflict();

    $accsli("input:radio:checked").data("chk", true);

    $accsli("input:radio").click(function() {
        $accsli("input[name='" + $accsli(this).attr("name") + "']:radio").not(this).removeData("chk");
        $accsli(this).data("chk", !$accsli(this).data("chk"));
        $accsli(this).prop("checked", $accsli(this).data("chk"));
    });

    $accsli(".start").click(function() {
        $accsli(this).toggleClass('grey');
        $accsli(this).css('visibility', 'hidden');
        $accsli(this).text($accsli(this).text() == 'Start' ? "Pause" : "Start");
        $accsli(".open-block").toggleClass("fade-block");
    });

    $accsli("#end_game").click(function() {
        $accsli(".open-block").toggleClass("fade-block");
        $accsli(".start").removeClass("grey");
        $accsli(".start").html("Start");
    });

    $accsli(".to-do-toggle").click(function() {
        $accsli(".stopwatch").slideToggle("fast");
        $accsli(".quiz-number").slideToggle("fast");
        $accsli(".game-info").slideToggle("fast");
        $accsli(".pdf").slideToggle("fast");
        $accsli(".to-do-toggle i").toggle();
    });

    $accsli("#submit").click(function() {
        //stopwatch
        var stopwatch = $accsli("#stopwatch").html();
        $accsli("#timervalue").val(stopwatch);
    });

    $accsli(".rest-game-ans").mouseover(function() {
        $accsli(".ans-selection").removeClass("active");
        $accsli(".ans-selection" + $accsli(this).attr('datavalue')).addClass("active");
    });

    var Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        // Variables privadas
        var links = this.el.find('.link');
        // Evento
        links.on('click', {
            el: this.el,
            multiple: this.multiple
        }, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
        var $el = e.data.el;
        var $this = $accsli(this);
        var $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        };
    }

    var accordion = new Accordion($accsli('#accordion'), false);
}